import { useSLAs } from './use-slas';

export type UseSLAByIssueTypeIssueSubtypeAndSeverityParams = {
  issueType: string;
  issueSubtype?: string;
  severity?: string;
};

export function useSLAByIssueTypeIssueSubtypeAndSeverity(
  params: UseSLAByIssueTypeIssueSubtypeAndSeverityParams,
) {
  const { issueType, issueSubtype, severity } = params;

  const slasQuery = useSLAs({
    filter: {
      issueType,
      issueSubtype,
      severity,
    },
    enabled: !!issueType && !!severity,
  });
  const matchingSLA = slasQuery.data?.data?.[0];
  return { slasQuery, matchingSLA };
}
